import { Component, OnInit } from "@angular/core";
import { JwtService } from "../../services/jwt.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-logout",
  templateUrl: "./logout.component.html",
  styleUrls: ["./logout.component.css"]
})
export class LogoutComponent implements OnInit {
  count: number = 3;
  interval: any;
  constructor(private jwt: JwtService, private router: Router) {}

  ngOnInit() {
    this.interval = setInterval(() => {
      if (this.count <= 0) {
        clearInterval(this.interval);
        this.jwt.removeToken();
        this.router.navigate(["/login"]);
      }
      this.count--;
    }, 1000);
  }
  cancelLogout() {
    clearInterval(this.interval);
    this.router.navigate(['/dashboard']);
  }
}
